import axios from 'axios'
import store from '../vuex/index'
import Authenticator from '../lib/Authenticator'

export default function setup () {
  const auth = new Authenticator()
  axios.interceptors.request.use(async (config) => {
    const authData = await auth.getAccessToken(store.state.accessToken, store.state.expiresAt)
    config.headers.Authorization = `Bearer ${authData.accessToken}`

    // if tokens were renewed then update the store
    if (!authData.isExistingTokenValid) {
      store.dispatch('updateAuthData', authData)
    }

    // return the configuration with the token header
    return config
  }, (error) => {
    return Promise.reject(error)
  })
}
